<template>
  <div>
    <right-panel class="float-right" id="sidebar-announcement-detail" width="800px" :icon="'mdi mdi-plus'">
      <div class="pl-5 pr-5">
        <announcement-detail :announcement="selectedAnnouncement" />
      </div>
    </right-panel>
    <!-- <AnnouncementModal ref="sidebar-announcement-detail" id="sidebar-announcement-detail" :announcement="selectedAnnouncement" />-->
    <div>
      <h2>{{ $t("announcement.plural") }}</h2>
    </div>

    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <!-- -- Contexts -->
        <thead class="bg-secondary text-white">
          <tr>
            <th>{{ $t("common.name") }}</th>
            <th>{{ $t("product.text") }}</th>
            <th>{{ $t("sector.text") }}</th>
            <th>{{ $t("announcement.date") }}</th>
            <th scope="col" style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filterEnabled">
            <th><input class="form-control " v-model="nameFilter" /></th>

            <th>
              <select class="form-control " v-model="productFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option v-for="item in products" :key="item" :value="item">{{ item }}</option>
              </select>
            </th>
            <th>
              <filter-select
                id="sectorFilter"
                ref="sectorFilter"
                :placeholder="$t('sector.text')"
                :multiple="false"
                @filter="onSectorSearch"
                :selected="sectorFilter"
                @changed="onSectorSelect"
              />
            </th>
            <th><date-picker v-model="dateFilter" :first-day-of-week="1" lang="tr" format="DD.MM.YYYY" value-type="timestamp" placeholder="Örn: 21.11.2020" /></th>
            <th></th>
          </tr>

          <template v-if="pagination">
            <!-- -- table data start -->
            <tr v-for="item in pagination.docs" :key="item._id">
              <td>{{ item.name | translate }}</td>

              <td>
                {{ item.product }}
              </td>
              <td>
                {{ item.sector.name | translate }}
              </td>

              <td>{{ item.dueDate | date }}</td>

              <td>
                <div class="font-size-16 text-center">
                  <i
                    class="bx bx-search text-primary hand"
                    v-b-tooltip.hover
                    :title="$t('announcement.detail')"
                    v-b-modal="'announcement-modal'"
                    @click="announcementDetail(item)"
                  ></i>
                </div>
              </td>
            </tr>
            <!-- --table data end -->
          </template>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />

    <!-- Begin: Pagination -->
    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("announcement.no") }}
      </h5>
    </empty>

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import AnnouncementDetail from "./announcement-detail";
//import AnnouncementModal from "./AnnouncementModal.vue";
import DatePicker from "vue2-datepicker";

const state = "announcement";

export default {
  components: {
    AnnouncementDetail,
    DatePicker,
    // AnnouncementModal,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15 },
        query: {},
      },
      dateFilter: undefined,
      nameFilter: undefined,
      productFilter: undefined,
      sectorFilter: undefined,
      filterEnabled: false,
      selectedAnnouncement: undefined,
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
    productFilter(n, o) {
      if (!n) {
        this.request.query = { ...this.request.query, product: undefined };
        return;
      }
      this.request.query = {
        ...this.request.query,
        product: { value: n, isObject: true },
      };
    },
    dateFilter(n, o) {
      if (!n) {
        this.request.query = { ...this.request.query, dueDate: undefined };
        return;
      }
      this.request.query = { ...this.request.query, dueDate: { value: n, isObject: true } };
    },
    sectorFilter(n, o) {
      if (!n) {
        this.request.query = { ...this.request.query, sector: undefined };
        return;
      }

      this.request.query = { ...this.request.query, sector: { value: n._id, isObject: true } };
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    selectedOrganization() {
      return this.$store.getters["organization/selected"];
    },
  },
  mounted() {
    this.products = Products;
  },
  methods: {
    init() {
      this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    announcementDetail(item) {
      this.selectedAnnouncement = item;
      this.$root.$emit("bv::toggle::collapse", "sidebar-announcement-detail");
      // this.$root.$emit("bv::toggle::modal", "sidebar-announcement-detail");
      //  this.$refs["sidebar-announcement-detail"].show();
    },
    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`sector/paginate`, {
        options: { limit: 20 },
        query: { name: { value: value } },
      });

      callback(response.data.docs ?? []);
    },
    onSectorSelect(item) {
      this.sectorFilter = item;
    },
  },
};
</script>
